import { inject, Pipe, PipeTransform } from '@angular/core';
import { COUNTRIES } from '../../models/constants/countries.const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'countryName',
})
export class CountryNamePipe implements PipeTransform {
  readonly #translateService = inject(TranslateService);

  preValue = '';
  result = '';

  transform(value: string | undefined | null): string {
    if (value && value !== this.preValue) {
      this.preValue = value;
      try {
        this.result = this.#translateService.instant(COUNTRIES[value].translationKey);
      } catch {
        // fallback return the value.
        this.result = value;
      }
    }
    return this.result;
  }
}

@Pipe({
  name: 'countryNameStandalone',
  standalone: true,
})
export class CountryNamePipeStandalone implements PipeTransform {
  preValue = '';
  result = '';
  readonly #translateService = inject(TranslateService);

  transform(value: string | undefined | null): string {
    if (value && value !== this.preValue) {
      this.preValue = value;
      try {
        this.result = this.#translateService.instant(COUNTRIES[value].translationKey);
      } catch {
        // fallback return the value.
        this.result = value;
      }
    }
    return this.result;
  }
}
